import { Provider } from '@angular/core';

import { BREADCRUMB_TRANSLATION_PROVIDER } from './translation-providers/breadcrumb-translations.provider';
import { CART_MESSAGES_TRANSLATIONS_PROVIDER } from './translation-providers/cart-messages-translations.provider';
import { COMMON_PAGE_TITLE_TRANSLATION_PROVIDER } from './translation-providers/common-page-title-translation.provider';
import { CONSENT_MANAGEMENT_TRANSLATION_PROVIDER } from './translation-providers/consent-management-translations.provider';
import { DATE_TRANSLATION_PROVIDER } from './translation-providers/date-translation.provider';
import { DOCUMENT_UPLOAD_TRANSLATIONS_PROVIDER } from './translation-providers/document-upload-translations.provider';
import { INDICATOR_LABEL_TRANSLATIONS_PROVIDER } from './translation-providers/indicator-label-translations.provider';
import { MASTERCARD_TRANSLATIONS_PROVIDER } from './translation-providers/mastercard-translations.provider';
import { OPTION_CARDS_TRANSLATIONS_PROVIDER } from './translation-providers/option-cards-translations.provider';
import { RIBBON_TRANSLATIONS_PROVIDER } from './translation-providers/ribbon-translations.provider';
import { ROUTER_BREADCRUMB_TRANSLATION_PROVIDER } from './translation-providers/router-breadcrumb-translation.provider';
import { SMARTBAR_TRANSLATIONS_PROVIDER } from './translation-providers/smartbar-translations.provider';
import { VALIDATION_MESSAGES_PROVIDER } from './translation-providers/validation-messages.provider';

export const TRANSLATION_PROVIDERS: Provider[] = [
  VALIDATION_MESSAGES_PROVIDER,
  DATE_TRANSLATION_PROVIDER,
  ROUTER_BREADCRUMB_TRANSLATION_PROVIDER,
  BREADCRUMB_TRANSLATION_PROVIDER,
  CONSENT_MANAGEMENT_TRANSLATION_PROVIDER,
  SMARTBAR_TRANSLATIONS_PROVIDER,
  RIBBON_TRANSLATIONS_PROVIDER,
  INDICATOR_LABEL_TRANSLATIONS_PROVIDER,
  DOCUMENT_UPLOAD_TRANSLATIONS_PROVIDER,
  MASTERCARD_TRANSLATIONS_PROVIDER,
  OPTION_CARDS_TRANSLATIONS_PROVIDER,
  CART_MESSAGES_TRANSLATIONS_PROVIDER,
  COMMON_PAGE_TITLE_TRANSLATION_PROVIDER
];
